var React = require('react');

function Supercar32px (props) {
    return React.createElement("symbol",props,[React.createElement("defs",{"key":0}),React.createElement("path",{"d":"M31 19.241V21a1 1 0 0 1-1 1h-7a1 1 0 0 1-1-1v-1H10v1a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1v-1.759a2.942 2.942 0 0 1-1-2.202v-4.29c0-2.582 1.545-4.651 4.028-5.609a.976.976 0 0 1 .078-.587l2-4C7.046.671 11.835 0 16.003 0c.392 0 9.629.029 10.892 2.552l2.024 5.053C30.847 8.7 32 10.541 32 12.749v4.29c0 .878-.391 1.659-1 2.202zM21.747 18a8.359 8.359 0 0 1-.814-1.417A1.673 1.673 0 0 0 19.668 16h-7.336a1.67 1.67 0 0 0-1.265.583A8.398 8.398 0 0 1 10.253 18h11.494zM25.11 3.467C24.566 2.927 21.149 2 16.003 2c-5.436 0-7.851 1.07-8.115 1.459L6.314 6.608C7.954 6.418 12.023 6 16 6c5.007 0 10.173.664 10.391.692l.01.003-1.291-3.228zM30 12.749c0-2.073-1.502-3.637-3.919-4.082C26.07 8.667 20.869 8 16 8c-4.874 0-10.081.668-10.133.675C3.499 9.092 2 10.655 2 12.749v4.29c0 .53.431.961.961.961H7c1.104 0 2.075-1.825 2.275-2.313.033-.079.075-.153.125-.221A3.681 3.681 0 0 1 12.332 14h7.336a3.68 3.68 0 0 1 2.931 1.466c.051.068.093.142.126.221C22.973 16.286 23.926 18 25 18h4.039c.53 0 .961-.431.961-.961v-4.29zm-1.684.2l-3 1a.999.999 0 0 1-.632-1.898l3-1a1 1 0 1 1 .632 1.898zM7 14a.995.995 0 0 1-.316-.051l-3-1a1 1 0 0 1 .632-1.898l3 1A1 1 0 0 1 7 14z","key":1})]);
}

Supercar32px.displayName = "Supercar32px";

Supercar32px.defaultProps = {"preserveAspectRatio":"xMidYMid","viewBox":"0 0 32 22"};

module.exports = Supercar32px;

Supercar32px.default = Supercar32px;



//////////////////
// WEBPACK FOOTER
// ./data/assets/sprites/32px/supercar-32px.svg
// module id = 1115
// module chunks = 0